import {Trans} from '@lingui/macro';
import React from 'react';

import {ColumnWidthsEnum} from '../../../../libs/contacts-manager/src/lib/ui/web/tables/common/sharedTableConfig';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
  VirtualTableSortableColumnDirectionsEnum,
} from '../../../components/common/table/helpers/tableHelpers';
import {SortableTableColumn, TableColumn} from '../../../components/common/table/tableColumn';

/*
 * Constants.
 */

export const signaturesTableNameColumnId = 'signatures-table-name';
export const signaturesTableOrderColumnId = 'signatures-table-order';

export enum SignaturesTableColumnsEnum {
  NAME = 'name',
  ORDER = 'order',
}

export const signaturesTableSortableColumns: ReadonlyArray<SortableTableColumn> = [
  {
    id: signaturesTableOrderColumnId,
    directions: [
      VirtualTableSortableColumnDirectionsEnum.ASCENDING,
      VirtualTableSortableColumnDirectionsEnum.DESCENDING,
    ],
  },
];

export const signaturesTableColumns: ReadonlyArray<TableColumn<SignaturesTableColumnsEnum>> = [
  {
    id: signaturesTableNameColumnId,
    title: <Trans id="signatures-table-column-name">Name</Trans>,
    type: SignaturesTableColumnsEnum.NAME,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: ColumnWidthsEnum.LARGE,
      },
      loading: {
        avatarSize: VisualSizesEnum.LARGE,
      },
    },
  },
  {
    id: signaturesTableOrderColumnId,
    title: <Trans id="signatures-table-column-order">Order</Trans>,
    type: SignaturesTableColumnsEnum.ORDER,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        minWidth: ColumnWidthsEnum.LARGE,
      },
    },
  },
];
